export default __webpack_public_path__ + "static/media/cosmetics-mobile.7fa5e195.png";